<div>
    Item Patrol © 2018-{{ year }}
</div>
<div class="hidden md:block lg:block xl:block">
    Powered by Angular v19 -{{ appInfo.buildSourceBranch }}_{{ appInfo.buildNumber }}
</div>